<template>
    <ListView
        ref="list"
        title="Uploads"
        :show-id="false"
        :api-paging="false"
        :api-search="false"
        :api-rename="require('@/common/api').default.storageRename"
        :api-create-folder="require('@/common/api').default.storageCreateFolder"
        :api-delete="require('@/common/api').default.storageDeleteFile"
        :api-list="require('@/common/api').default.storage"
        :columns="[
            { title: 'Name', name: 'name' },
            { title: 'Size', name: 'size', type: 'custom' },
            { title: 'Modified', name: 'modified', type: 'datetime', sortable: true }
        ]"
        use-folders
        :menu-items="menuItems">
        <template v-slot:top>
            <input style="display: none;" ref="file-upload" id="file_upload" type="file" multiple v-on:change="uploadFile($event.target.files)" />
            <label class="btn btn-primary" for="file_upload">Upload</label>
        </template>
        <template v-slot:custom="props">
            <div v-if="props.column.name === 'size'">
                <span v-if="props.item.size">
                    {{formatFileSize(props.item.size, 2)}}
                </span>
            </div>
        </template>
    </ListView>
    <folder-picker
        ref="folder-picker"
        :api-list="require('@/common/api').default.storage"
        :columns="[
            { title: 'Name', name: 'name' },
            { title: 'Size', name: 'size', type: 'custom' },
            { title: 'Modified', name: 'modified', type: 'datetime', sortable: true }
        ]">
        <template v-slot:custom="props">
            <div v-if="props.column.name === 'size'">
                <span v-if="props.item.size">
                    {{formatFileSize(props.item.size, 2)}}
                </span>
            </div>
        </template>
    </folder-picker>
</template>

<script>
import ListView from "@/views/templates/ListView.vue";
import { formatFileSize } from "@/utils/browser";
import api from "@/common/api";
import FolderPicker from "@/components/local/FolderPicker.vue";

export default {
    components: {
        FolderPicker,
        ListView
    },
    data() {
        return {
            loaded: false,
            menuItems: [
                { title: "Download", callback: this.downloadFile },
                { title: "Move", callback: this.moveItem }
            ],

            selectedFile: null
        };
    },
    methods: {
        formatFileSize,
        downloadFile(file) {
            window.open(file.download_url);
        },
        moveItem(item) {
            this.$refs["folder-picker"].open((folder, close) => {
                close();
                api.storageRename(item.id, item.name, folder).then(() => {
                    this.load();
                }).catch(e => {
                    this.flashError(e);
                });
            });
        },
        uploadFile(files) {
            const list = [];
            for (let i = 0; i < files.length; i++) {
                const f = files[i];
                list["file_" + i] = f;
            }

            this.loaded = false;
            api.storageUpload(list).then(data => {
                this.loaded = true;
                this.$refs.list.load();
                this.$refs["file-upload"].value = "";
            }).catch(e => {
                this.flashError(e);
                this.loaded = true;
            });
        },
        load() {
            this.$refs.list.load();
        }
    }
};
</script>
